export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0a4 4 0 00-4 4v1H3a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1V4a4 4 0 00-4-4zm2 5V4a2 2 0 10-4 0v1h4z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};